<template>
  <b-modal
      :id="idModal"
      :title="`Perfis de acesso — ${tipoPedido ? tipoPedido.tipopedidodescricao : ''}`"
      size="md"
      cancel-title="Cancelar"
      ok-title="Salvar"
      ok-variant="primary"
      :busy="saving"
      @show="onShow"
      @ok="handleOk"
  >
    <b-overlay :show="loading">
      <p class="text-muted mb-1">
        Selecione quais perfis de acesso podem visualizar/selecionar este tipo de
        pedido na tela de Novo Pedido.
      </p>
      <b-alert variant="info" show class="p-1 small">
        Se nenhum perfil for selecionado, o tipo de pedido fica visível para
        <strong>todos</strong> os perfis.
      </b-alert>

      <div v-if="perfis.length === 0 && !loading" class="text-center text-muted py-2">
        Nenhum perfil de acesso encontrado.
      </div>

      <b-form-group v-else class="mb-0">
        <div
            v-for="perfil in perfis"
            :key="perfil.id"
            class="d-flex justify-content-between align-items-center py-50 border-bottom"
        >
          <span>{{ perfil.perfil_acesso_nome }}</span>
          <b-form-checkbox
              v-model="selecionados"
              :value="perfil.id"
              switch
              inline
              class="mr-0"
          />
        </div>
      </b-form-group>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  BAlert,
  BFormGroup,
  BFormCheckbox,
} from 'bootstrap-vue';
import axios from '@axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import SLSTipoPedidoService from '@/services/SistemaDKP/SLSTipoPedido.service';

export default {
  components: {
    BModal,
    BOverlay,
    BAlert,
    BFormGroup,
    BFormCheckbox,
  },
  props: {
    idModal: {
      type: String,
      default: 'modal-perfis-tipo-pedido',
    },
    tipoPedido: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      service: new SLSTipoPedidoService(),
      perfis: [],
      selecionados: [],
      loading: false,
      saving: false,
    };
  },
  methods: {
    async onShow() {
      if (!this.tipoPedido || !this.tipoPedido.tipopedidoid) return;
      this.loading = true;
      this.perfis = [];
      this.selecionados = [];
      try {
        const [perfisResp, atuaisResp] = await Promise.all([
          axios.get('/perfilAcesso/findAll', { params: { perPage: 1000 } }),
          this.service.getPerfis(this.tipoPedido.tipopedidoid),
        ]);
        const root = (perfisResp && perfisResp.data) || {};
        const lista = Array.isArray(root) ? root : (root.data || []);
        this.perfis = lista
          .filter((p) => p && p.id != null)
          .sort((a, b) => String(a.perfil_acesso_nome || '')
            .localeCompare(String(b.perfil_acesso_nome || '')));
        const atuais = (atuaisResp && atuaisResp.data) || [];
        this.selecionados = atuais.map((id) => parseInt(id, 10));
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Não foi possível carregar os perfis de acesso.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (!this.tipoPedido || !this.tipoPedido.tipopedidoid) return;
      this.saving = true;
      const result = await this.service.setPerfis(
        this.tipoPedido.tipopedidoid,
        this.selecionados,
      );
      this.saving = false;
      if (result) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Perfis do tipo de pedido atualizados com sucesso.',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        this.$emit('saved');
        this.$nextTick(() => this.$bvModal.hide(this.idModal));
      }
    },
  },
};
</script>
